import { Link } from "react-router-dom";
import { BIKES, SCOOTERS } from "@/data/products";
import { Zap, Battery, Shield, Power } from "lucide-react";

const Home = () => {
  return (
    <div className="home" data-testid="home-page">
      {/* HERO */}
      <section className="hero" id="top">
        <div className="hero-bg" aria-hidden="true" />
        <div className="hero-inner">
          <p className="eyebrow">/ ELECTRIC PERFORMANCE BIKES</p>
          <h1 className="hero-title">
            RIDE <span className="accent">THE</span><br />LIGHTNING.
          </h1>
          <p className="hero-sub">
            Built for the rider who refuses to coast. Carbon, copper, and code
            engineered into electric machines that bend cities and break trails.
          </p>
          <div className="hero-cta">
            <a href="#bikes" className="btn btn-primary" data-testid="cta-shop">
              SHOP THE FLEET <span>→</span>
            </a>
            <a href="#about" className="btn btn-ghost" data-testid="cta-about">OUR STORY</a>
          </div>
        </div>
      </section>

      {/* MARQUEE */}
      <div className="marquee" aria-hidden="true">
        <div className="marquee-track">
          {Array.from({ length: 8 }).map((_, i) => (
            <span key={i} className="marquee-item">
              ERYDON BIKES <em>•</em> RIDE THE LIGHTNING <em>•</em>
            </span>
          ))}
        </div>
      </div>

      {/* FEATURES */}
      <section className="features" id="about">
        <div className="feature">
          <Zap size={40} strokeWidth={1.75} className="feature-icon" />
          <h3>1000W MID-DRIVE</h3>
          <p>Custom-tuned motors. Instant torque. Zero hesitation.</p>
        </div>
        <div className="feature feature-big">
          <p className="feature-eyebrow">/ ANY TERRAIN. NO APOLOGIES.</p>
          <h2>Urban grids, fire roads, climbs that say no — Erydon says go.</h2>
        </div>
        <div className="feature">
          <Battery size={40} strokeWidth={1.75} className="feature-icon" />
          <h3>160 KM RANGE</h3>
          <p>High-density cells, regen braking, and a 1000Wh reserve for the long haul.</p>
        </div>
      </section>

      <section className="warranty-strip">
        <Shield size={28} strokeWidth={1.75} />
        <div>
          <p className="warranty-eyebrow">/ LIFETIME FRAME WARRANTY</p>
          <h3>WE STAND BEHIND EVERY BOLT.</h3>
        </div>
      </section>

      {/* LINEUP */}
      <section className="lineup" id="bikes">
        <div className="lineup-head">
          <p className="eyebrow">/ THE LINEUP</p>
          <h2>FEATURED BIKES</h2>
        </div>

        <div className="bike-grid">
          {BIKES.map((p) => (
            <Link
              to={`/product/${p.slug}`}
              key={p.id}
              className="bike-card"
              data-testid={`bike-card-${p.slug}`}
            >
              <div className="bike-image-wrap">
                <img src={p.colors[0]?.image || p.image} alt={p.name} loading="lazy" />
              </div>
              <div className="bike-info">
                <p className="bike-tag">{p.tagline}</p>
                <h4 className="bike-name">{p.name}</h4>
                <p className="bike-desc">{p.shortDesc}</p>
                <div className="bike-meta">
                  <span className="bike-color">COLOR: <strong>{p.colors[0].name}</strong></span>
                </div>
                <div className="bike-foot">
                  <span className="bike-price">€{p.price}</span>
                  <span className="bike-arrow">→</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* SCOOTERS */}
      <section className="lineup" id="scooters">
        <div className="lineup-head">
          <p className="eyebrow">/ THE CITY FLEET</p>
          <h2>ELECTRIC SCOOTERS</h2>
        </div>

        <div className="bike-grid">
          {SCOOTERS.map((p) => (
            <Link
              to={`/product/${p.slug}`}
              key={p.id}
              className="bike-card"
              data-testid={`scooter-card-${p.slug}`}
            >
              <div className="bike-image-wrap">
                <img src={p.colors[0]?.image || p.image} alt={p.name} loading="lazy" />
              </div>
              <div className="bike-info">
                <p className="bike-tag">{p.tagline}</p>
                <h4 className="bike-name">{p.name}</h4>
                <p className="bike-desc">{p.shortDesc}</p>
                <div className="bike-meta">
                  <span className="bike-color">COLOR: <strong>{p.colors[0].name}</strong></span>
                </div>
                <div className="bike-foot">
                  <span className="bike-price">€{p.price}</span>
                  <span className="bike-arrow">→</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-top">
          <div className="footer-brand">
            <span className="logo-mark sm">E</span>
            <span className="logo-text">ERYDON / BIKES</span>
          </div>
          <p className="footer-blurb">
            Hand-tuned electric performance bikes. Built in small batches, ridden hard.
          </p>
        </div>
        <div className="footer-bottom">
          <Link to="/admin" className="footer-admin-btn" data-testid="footer-admin-btn">
            <Power size={12} strokeWidth={2.5} />
            <span>ADMIN</span>
          </Link>
          <span className="footer-copy">© {new Date().getFullYear()} ERYDON BIKES</span>
        </div>
      </footer>
    </div>
  );
};

export default Home;
